import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, message } from '@common/musicHubCommon';
import { useUserStore } from '../../../store';
import { ROUTES } from '../../../routes';
import './index.scss';

const OnboardingName: React.FC = () => {
  const navigate = useNavigate();
  const updateUser = useUserStore((state) => state.updateUser);
  const [loading, setLoading] = useState(false);
  const [artistName, setArtistName] = useState('');
  const [form] = Form.useForm();

  const isFormValid = artistName.trim().length > 0;

  const handleSubmit = async (values: { artistName: string }) => {
    if (!values.artistName?.trim()) {
      message.error('Please enter your artist name');
      return;
    }

    setLoading(true);

    console.log(values);
    // 模拟 API 调用
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // 更新用户数据
    updateUser({ name: values.artistName.trim() });
    
    setLoading(false);
    
    // 跳转到下一步
    navigate(ROUTES.onboardingProfile);
  };

  return (
    <div className="onboarding-name">
      <div className="onboarding-name__content">
        {/* 标题区域 */}
        <div className="onboarding-name__header">
          <div className="title-container">
            <img src='https://akoss.bangcdn.net/fe/profilename.webp' alt="Create Artist Profile" className="title-image" />
          </div>
          <p className="subtitle">Let's start by telling us your artist name</p>
        </div>

        {/* 表单区域 */}
        <div className="onboarding-name__form">
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <Form.Item
              name="artistName"
              label={<span className="form-label">Stage Name</span>}
              rules={[{ required: true, message: 'Please enter your artist name' }]}
            >
              <Input 
                placeholder="Enter your stage name" 
                value={artistName}
                onChange={(e) => setArtistName(e.target.value)}
              />
            </Form.Item>

            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                disabled={!isFormValid}
                className={`submit-btn ${!isFormValid ? 'submit-btn--disabled' : ''}`}
              >
                Next
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default OnboardingName;
